import { all, call, put, takeEvery } from 'redux-saga/effects';
import SUCCESS_MESSAGES from '../../../common/constants/SuccessMessagesConstants';
import { request } from '../../../common/util/RestClient';
import envConfig from '../../../config';
import { moveLinkedEntities, moveEntity } from '../../routines';
import { LEVEL_360_MAPPING } from '../../../common/constants/EntityScopeConstants';
import {
  fetchMethodByScope,
  fetchMethodMapping,
} from '../../../common/constants/EntityActions';
import { LEVEL_ID_FIELD } from '../../../common/constants/CommonConstants';

function* move(
  entityLevel,
  currentEntityId,
  formData,
  fetchLevel,
  fetchId,
  routine,
  successMessage,
  scope
) {
  const URL = `${envConfig.APIG_URL}core/${entityLevel}s/${currentEntityId}/move`;
  const config = {
    method: 'POST',
    payload: formData,
  };
  const response = yield call(request, URL, config);
  yield put(
    routine.success({
      response,
      successMessage,
    })
  );

  if (scope && Object.values(LEVEL_360_MAPPING).includes(scope)) {
    yield put(
      fetchMethodByScope[scope].trigger({
        [`${LEVEL_ID_FIELD[fetchLevel]}`]: fetchId,
      })
    );
  } else {
    yield put(
      fetchMethodMapping[fetchLevel].trigger({
        usePrevPayload: true,
        preservePreviousList: false,
        isAfterAction: true,
      })
    );
  }
}

export function* moveLinkedEntitySaga({ payload }) {
  try {
    const { level, entityId, formData, scope } = payload;
    yield* move(
      level,
      entityId,
      formData,
      level,
      entityId,
      moveLinkedEntities,
      SUCCESS_MESSAGES.MOVE_LINKED_ENTITIES,
      scope
    );
  } catch (error) {
    yield put(moveLinkedEntities.failure({ error }));
  }
}

export function* moveEntitySaga({ payload }) {
  try {
    const { entityId, entityLevel, parentId, parentLevel, formData, scope } =
      payload;
    yield* move(
      parentLevel,
      parentId,
      formData,
      entityLevel,
      entityId,
      moveEntity,
      SUCCESS_MESSAGES.MOVE_ACCOUNT,
      scope
    );
  } catch (error) {
    yield put(moveEntity.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeEvery(moveLinkedEntities.TRIGGER, moveLinkedEntitySaga),
    takeEvery(moveEntity.TRIGGER, moveEntitySaga),
  ]);
}
